import { z } from 'zod';

export const CREDIT_LIMIT_KINDS = ['default', 'plan', 'organization'] as const;
export const CreditLimitKindSchema = z.enum(CREDIT_LIMIT_KINDS);
export type CreditLimitKind = z.infer<typeof CreditLimitKindSchema>;

export const CreditLimitInputSchema = z
  .object({
    kind: CreditLimitKindSchema,
    subject: z.string().max(256),
    monthlyCreditMicros: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
  })
  .refine((limit) => (limit.kind === 'default') === (limit.subject === ''), {
    message: 'the default limit has an empty subject; a plan or organization limit names one',
    path: ['subject'],
  });
export type CreditLimitInput = z.infer<typeof CreditLimitInputSchema>;

export interface CreditClient {
  readonly organizationSubject: string | null;
  readonly plan: string | null;
}

export function effectiveCreditLimit<Limit extends CreditLimitInput>(
  limits: readonly Limit[],
  client: CreditClient,
): Limit | null {
  const find = (kind: CreditLimitKind, subject: string | null) =>
    subject === null
      ? undefined
      : limits.find((limit) => limit.kind === kind && limit.subject === subject);
  return (
    find('organization', client.organizationSubject) ??
    find('plan', client.plan) ??
    find('default', '') ??
    null
  );
}

export function startOfUtcMonth(at: Date): Date {
  return new Date(Date.UTC(at.getUTCFullYear(), at.getUTCMonth(), 1));
}
